import { BrowserRouter, Route, Routes } from 'react-router';
import { PwaInstallCoach } from './components/pwa/PwaInstallCoach.js';
import { PwaUpdateToast } from './components/pwa/PwaUpdateToast.js';
import RequireAuth from './components/RequireAuth.js';
import RootLayout from './layouts/RootLayout.js';
import BillingCancelPage from './pages/BillingCancelPage.js';
import BillingSuccessPage from './pages/BillingSuccessPage.js';
import ChatHistoryPage from './pages/ChatHistoryPage.js';
import ChatPage from './pages/ChatPage.js';
import CoachingPage from './pages/CoachingPage.js';
import HomePage from './pages/HomePage.js';
import LoginPage from './pages/LoginPage.js';
import MeasurementsPage from './pages/MeasurementsPage.js';
import PlanningPage from './pages/PlanningPage.js';
import PremiumPage from './pages/PremiumPage.js';
import RegisterPage from './pages/RegisterPage.js';
import SettingsPage from './pages/SettingsPage.js';
import SharingAcceptPage from './pages/SharingAcceptPage.js';
import SharingPage from './pages/SharingPage.js';
import VerifyPhonePage from './pages/VerifyPhonePage.js';
import WeightPage from './pages/WeightPage.js';

export default function App() {
  return (
    <BrowserRouter>
      <PwaInstallCoach />
      <PwaUpdateToast />
      <Routes>
        {/* Public auth routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Authenticated app — gated by a Better-Auth session */}
        <Route element={<RequireAuth />}>
          {/*
           * Standalone post-registration step (ADR-0018 §3 / ISSUE-064).
           * Rendered outside RootLayout so it has no navigation chrome.
           * ISSUE-011 will redirect users here automatically after first sign-in
           * once the full onboarding flow is built.
           */}
          <Route path="verify-phone" element={<VerifyPhonePage />} />

          <Route element={<RootLayout />}>
            <Route index element={<HomePage />} />
            <Route path="weight" element={<WeightPage />} />
            <Route path="coaching" element={<CoachingPage />} />
            <Route path="planning" element={<PlanningPage />} />
            <Route path="measurements" element={<MeasurementsPage />} />
            <Route path="sharing" element={<SharingPage />} />
            <Route path="sharing/accept" element={<SharingAcceptPage />} />
            <Route path="premium" element={<PremiumPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="chat" element={<ChatHistoryPage />} />
            <Route path="chat/new" element={<ChatPage />} />
            <Route path="chat/:threadId" element={<ChatPage />} />
            {/* Web billing return routes (ADR-0022 §4). */}
            <Route path="billing/success" element={<BillingSuccessPage />} />
            <Route path="billing/cancel" element={<BillingCancelPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
